export const ROOT_FRANCHISE_SLUG = "lavoris";
export const FRANCHISE_HEADER = "X-Franchise-Slug";

/** Sufijo para claves de storage por tenant (vacío en root). */
export function getTenantStorageSuffix(
  slug: string | null = currentFranchiseSlug,
): string {
  return slug ? `:${slug}` : "";
}

export function getPersistStorageKey(
  slug: string | null = currentFranchiseSlug ??
    resolveFranchiseSlugFromPath(),
): string {
  return `lavoris${getTenantStorageSuffix(slug)}`;
}

export function getTokenStorageKey(
  slug: string | null = currentFranchiseSlug ??
    resolveFranchiseSlugFromPath(),
): string {
  return `lavoris:tokens${getTenantStorageSuffix(slug)}`;
}

export function buildTenantPath(path: string): string {
  const base = getRouterBasename();
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (base === "/") return normalized;
  return `${base.replace(/\/$/, "")}${normalized}`;
}

const SOCIOS_PATH_REGEX = /^\/socios\/([^/]+)/i;

let currentFranchiseSlug: string | null = null;

/**
 * Detecta el slug de franquicia desde `/socios/:slug`. Null = tenant raíz Lavoris.
 * Con BrowserRouter basename=`/socios/:slug`, el pathname de React Router es relativo
 * (ej. `/login`) y no incluye `/socios/...`. Si el path pasado no trae `/socios/`,
 * usamos `window.location.pathname` para no perder el tenant.
 */
export function resolveFranchiseSlugFromPath(
  pathname?: string,
): string | null {
  const browserPath =
    typeof window !== "undefined" ? window.location.pathname : "";
  const candidate =
    pathname && SOCIOS_PATH_REGEX.test(pathname)
      ? pathname
      : browserPath || pathname || "";
  const match = candidate.match(SOCIOS_PATH_REGEX);
  if (!match?.[1]) return null;

  const slug = match[1].trim().toLowerCase();
  if (!slug || slug === ROOT_FRANCHISE_SLUG || slug === "root") {
    return null;
  }

  return slug;
}

export function getRouterBasename(slug: string | null = currentFranchiseSlug): string {
  return slug ? `/socios/${slug}` : "/";
}

/** Slug a usar en `GET /franchises/public/:slug` (siempre un valor concreto). */
export function getBrandingSlug(slug: string | null = currentFranchiseSlug): string {
  return slug || ROOT_FRANCHISE_SLUG;
}

export function setCurrentFranchiseSlug(slug: string | null): void {
  currentFranchiseSlug = slug;
}

export function getCurrentFranchiseSlug(): string | null {
  return currentFranchiseSlug;
}

/** Valor del header: se omite en raíz Lavoris. */
export function getFranchiseHeaderValue(): string | undefined {
  return currentFranchiseSlug || undefined;
}

const AWS_IMAGES_HOST = "https://abs-certificates.s3.amazonaws.com";

export function resolveFranchiseLogoSrc(
  logoUrl?: string | null,
  fallback = "/images/Logo_Lavorix.png",
): string {
  if (!logoUrl) return fallback;
  if (/^https?:\/\//i.test(logoUrl) || logoUrl.startsWith("/")) {
    return logoUrl;
  }
  return `${AWS_IMAGES_HOST}/${logoUrl.replace(/^\//, "")}`;
}

// Inicializar desde la URL lo antes posible (antes de requests Axios).
if (typeof window !== "undefined") {
  setCurrentFranchiseSlug(resolveFranchiseSlugFromPath());
}
